//frontend/src/dropdownMap/1A1_dropdownFieldMapping.js

export const dropdownFieldsByIdx = {
    9: "ActivityType",
    10: "SubActivity",
    11: "ConductedBy",
    15: "Gender",
    16: "WomanHead",
    17: "PWBWStatus",
    18: "Responsibility",
    20: "PovertyLevel",
    21: "PWDStatus",
    22: "APGMember",
    23: "VNCAvailable",
};

export const dropdownOptions = {
    // Gender: {
    //     internal: ["_male", "_female"],
    //     LA: { "_male": "ຊາຍ", "_female": "ຍິງ" },
    //     EN: { "_male": "Male", "_female": "Female" }
    // },

    //internal values should match database stored values
    //LA and EN values are for display purpose


    ActivityType: {
        internal: ["subact_3", "subact_5", "subact_6"],
        LA: { "subact_3": "3", "subact_5": "5", "subact_6": "6" },
        EN: { "subact_3": "3", "subact_5": "5", "subact_6": "6" }
    },

    SubActivity: {
        internal: ["meet_authority", "hh_visit", "select_vnf_vf", "select_vnc", "demo_cooking"],
        LA: {
            "meet_authority": "ປະຊຸມເຜີຍແຜ່ໂຄງການໃຫ້ອໍານາດການປົກຄອງບ້ານ",
            "hh_visit": "ຢ້ຽມຢາມສວນຄົວ",
            "select_vnf_vf": "ການຄັດເລືອກ ຜູ້ອຳນວຍຄວາມສະດວກຂັ້ນບ້ານ",
            "select_vnc": "ການຄັດເລືອກ ຄະນະໂພຊະນາການບ້ານ",
            "demo_cooking": "ຈັດສາທິດການແຕ່ງອາຫານ"
        },
        EN: {
            "meet_authority": "Project orientation to village authority",
            "hh_visit": "Participatory Home garden visit implementation",
            "select_vnf_vf": "Selection of VNF/VF",
            "select_vnc": "Selection of VNC",
            "demo_cooking": "Cooking Demonstration session implementation"
        }
    },

    ConductedBy: {
        internal: ["pafo", "daec", "maf", "wfp", "dafo"],
        LA: { "pafo": "ພະແນກ ກປ ແຂວງ", "daec": "ກົມສົ່ງເສີມກະສິກຳ ແລະ ສະຫະກອນ", "maf": "ກະຊວງ ກປ", "wfp": "ອົງການອາຫານໂລກ", "dafo": "ຫ້ອງການ ກປ  ເມືອງ" },
        EN: { "pafo": "PAFO", "daec": "DAEC", "maf": "MAF", "wfp": "WFP", "dafo": "DAFO" }
    },

    Gender: {
        internal: ["Male", "Female"],
        LA: { "Male": "ຊາຍ", "Female": "ຍິງ" },
        EN: { "Male": "Male", "Female": "Female" }
    },

    WomanHead: {
        internal: ["h_no", "h_yes"],
        LA: { "h_no": "No", "h_yes": "Yes" },
        EN: { "h_no": "No", "h_yes": "Yes" }
    },

    PWBWStatus: {
        internal: ["bb_sitter", "pw_1", "bw", "vf", "pw"],
        LA: {
            "bb_sitter": "ຜູ້ປົກຄອງເດັກ",
            "pw_1": "ແມ່ຍິງຖຶພາຍັງມິລຸກຍັງກິນນົມ",
            "bw": "ແມ່ຍິງລ້ຽງລຸກດ້ວຍນົມແມ່",
            "vf": "ຜອບ",
            "pw": "ແມ່ຍິງຖືພາ"
        },
        EN: { "bb_sitter": "Baby sitter", "pw_1": "PBW", "bw": "BW", "vf": "VF", "pw": "PW" }
    },

    Responsibility: {
        internal: ["senior_person", "lwu", "option_2", "youth", "wfp_staff", "villager", "vnc", "option_1", "vnf", "gol_staff"],
        LA: {
            "senior_person": "ຜູ້ອາວຸໂສ (ເຖົ້າແກ່ ແນວໂຮມ)",
            "lwu": "ສະຫະພັນແມ່ຍິງ",
            "option_2": "ຮອງ ນາຍບ້ານ",
            "youth": "ຊາວໜຸ່ມ",
            "wfp_staff": "ພະນັກງານ ອົງການອາຫານໂລກ",
            "villager": "ຊາວບ້ານ",
            "vnc": "ຄະນະໂພຊະນາການບ້ານ",
            "option_1": "ນາຍບ້ານ",
            "vnf": "ຜູ້ອຳນວຍຄວາມສະດວກວຽກໂພຊະນາການຂັ້ນບ້ານ",
            "gol_staff": "ພະນັກງານຂອງລັດ"
        },
        EN: {
            "senior_person": "Senior person",
            "lwu": "LWU",
            "option_2": "VD-head",
            "youth": "Youth",
            "wfp_staff": "WFP staff",
            "villager": "Villager",
            "vnc": "VNC",
            "option_1": "V-head",
            "vnf": "VNF",
            "gol_staff": "GoL Staff"
        }
    },

    PovertyLevel: {
        internal: ["p", "np"],
        LA: { "p": "P", "np": "NP" },
        EN: { "p": "P", "np": "NP" }
    },

    PWDStatus: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    },

    APGMember: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    },

    VNCAvailable: {
        internal: ["0", "1", "2"],
        LA: { "0": "No", "1": "Yes", "2": "Yes" },
        EN: { "0": "No", "1": "Yes", "2": "Yes" }
    }
};

// Reverse mapping: LA → _male etc.
// export const dropdownReverseMap = {};
// Object.keys(dropdownOptions).forEach(field => {
//     dropdownReverseMap[field] = { LA: {}, EN: {} };
//     const opts = dropdownOptions[field];
//     opts.internal.forEach(intVal => {
//         dropdownReverseMap[field].LA[opts.LA[intVal]] = intVal;
//         dropdownReverseMap[field].EN[opts.EN[intVal]] = intVal;
//     });
// });
export const dropdownReverseMap = {};
Object.keys(dropdownOptions).forEach(field => {
    dropdownReverseMap[field] = { LA: {}, EN: {} };
    const opts = dropdownOptions[field];
    opts.internal.forEach(intVal => {
        const strVal = String(intVal); // force string
        dropdownReverseMap[field].LA[opts.LA[strVal]] = strVal;
        dropdownReverseMap[field].EN[opts.EN[strVal]] = strVal;
    });
});
